import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { casesApi } from '../../network/apis/cases';
import '../../assets/css/doctor/case.css'; // Reusing doctor case styles

const AHTCase = () => {
    const { caseId } = useParams();
    const navigate = useNavigate();
    const [caseData, setCaseData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchCaseDetails();
    });

    const fetchCaseDetails = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await casesApi.getCaseById(caseId);
            setCaseData(response?.data?.data || response?.data);
        } catch (err) {
            console.error('Failed to fetch case:', err);
            setError(err.message || 'Failed to fetch case details');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="case-container"><h2>Loading case details...</h2></div>;
    }

    if (error) {
        return (
            <div className="case-container">
                <div className="alert alert-error">{error}</div>
                <button onClick={() => navigate('/aht/cases')}>Back to Cases</button>
            </div>
        );
    }

    if (!caseData) {
        return (
            <div className="case-container">
                <div className="alert alert-warning">Case not found</div>
                <button onClick={() => navigate('/aht/cases')}>Back to Cases</button>
            </div>
        );
    }

    const getStatusColor = (status) => {
        const colors = {
            'PENDING': '#FFA500',
            'ASSIGNED': '#2196F3',
            'IN_PROGRESS': '#FF9800',
            'RESOLVED': '#4CAF50',
            'CANCELLED': '#f44336'
        };
        return colors[status] || '#999';
    };

    const getPriorityColor = (priority) => {
        const colors = {
            'HIGH': '#f44336',
            'MEDIUM': '#FF9800',
            'LOW': '#4CAF50'
        };
        return colors[priority] || '#999';
    };

    return (
        <div className="case-container">
            <button className="back-btn" onClick={() => navigate('/aht/cases')}>
                ← Back to Cases
            </button>

            <div className="case-details">
                <div className="case-header">
                    <h1>Case #{caseData.id}</h1>
                    <div className="badges">
                        <span 
                            className="badge status"
                            style={{ backgroundColor: getStatusColor(caseData.status) }}
                        >
                            {caseData.status}
                        </span>
                        <span 
                            className="badge priority"
                            style={{ backgroundColor: getPriorityColor(caseData.priority) }}
                        >
                            {caseData.priority} Priority
                        </span>
                    </div>
                </div>

                <div className="case-body">
                    <section className="case-section">
                        <h3>Case Information</h3>
                        <div className="info-grid">
                            <div className="info-item">
                                <label>Case ID</label>
                                <p>{caseData.id}</p>
                            </div>
                            <div className="info-item">
                                <label>Status</label>
                                <p>{caseData.status}</p>
                            </div>
                            <div className="info-item">
                                <label>Priority</label>
                                <p>{caseData.priority}</p>
                            </div>
                            <div className="info-item">
                                <label>Created Date</label>
                                <p>{new Date(caseData.created_at).toLocaleDateString()}</p>
                            </div>
                        </div>
                    </section>

                    {caseData.description && (
                        <section className="case-section">
                            <h3>Description</h3>
                            <p className="description">{caseData.description}</p>
                        </section>
                    )}

                    {caseData.symptoms && (
                        <section className="case-section">
                            <h3>Symptoms</h3>
                            <p>{caseData.symptoms}</p>
                        </section>
                    )}

                    {caseData.diagnosis && (
                        <section className="case-section">
                            <h3>Diagnosis</h3>
                            <p>{caseData.diagnosis}</p>
                        </section>
                    )}

                    {caseData.treatment && (
                        <section className="case-section">
                            <h3>Treatment</h3>
                            <p>{caseData.treatment}</p>
                        </section>
                    )}

                    {caseData.notes && (
                        <section className="case-section">
                            <h3>Notes</h3>
                            <p>{caseData.notes}</p>
                        </section>
                    )}
                </div>

                <div className="case-actions">
                    {caseData.status !== 'RESOLVED' && caseData.status !== 'CANCELLED' && (
                        <>
                            <button className="action-btn primary">Update Case</button>
                            <button className="action-btn secondary">Add Notes</button>
                        </>
                    )}
                    <button 
                        className="action-btn secondary"
                        onClick={() => navigate('/aht/cases')}
                    >
                        Back to Cases
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AHTCase;
